import { render, staticRenderFns } from "./wyProblemSell.vue?vue&type=template&id=36aea755&scoped=true&"
import script from "./wyProblemSell.vue?vue&type=script&lang=js&"
export * from "./wyProblemSell.vue?vue&type=script&lang=js&"
import style0 from "./wyProblemSell.vue?vue&type=style&index=0&id=36aea755&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aea755",
  null
  
)

export default component.exports